export default {
  userInfo: state => state.user.userInfo,
  roles: state => state.user.roles,
  addRoutes: state => state.permission.addRoutes
}


// WEBPACK FOOTER //
// ./src/store/getters.js